export default __webpack_public_path__ + "static/media/39.2f3fab96.png";